/**
 * Careers team slider: Swiper init, position arrows below image row, show text for active slide only.
 */
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

(function() {
    const section = document.querySelector('[data-js-careers-team]');
    if (!section) return;

    const swiperEl = section.querySelector('.careers-team-swiper');
    const arrows = section.querySelector('.careers-team-arrows');
    const prevBtn = section.querySelector('.careers-team-prev');
    const nextBtn = section.querySelector('.careers-team-next');
    const textBlocks = section.querySelectorAll('.careers-team__slide-text');

    if (!swiperEl || !prevBtn || !nextBtn) return;

    function positionArrows() {
        const firstSlide = swiperEl.querySelector('.swiper-slide');
        const imageWrap = firstSlide && firstSlide.querySelector('.careers-team__slide-image-wrap');
        if (imageWrap && arrows) {
            arrows.style.top = imageWrap.getBoundingClientRect().height + 'px';
        }
    }

    const total = textBlocks.length;

    function setActiveText(swiperInstance) {
        const perView = swiperInstance.params.slidesPerView;
        const realIndex = swiperInstance.realIndex;
        const activeIndex = perView === 3 ? (realIndex + 1) % total : realIndex;
        textBlocks.forEach(function(el, i) {
            el.style.opacity = i === activeIndex ? '1' : '0';
        });
    }

    const _swiper = new Swiper(swiperEl, {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        observer: true,
        observeParents: true,
        on: {
            init: function() {
                setActiveText(this);
            },
            slideChangeTransitionEnd: function() {
                setActiveText(this);
            },
        },
    });

    positionArrows();
    window.addEventListener('resize', positionArrows);
})();
